module.exports = __webpack_public_path__ + "static/media/ic-check2.0eb50ed1.svg";